import { bubEvents } from 'shared/events/bub_events';
import { SiteConversionTrackingHelper, SiteImpressions } from 'shared/events/site_conversion_tracking_helper';

$(document).ready(() => {
  if ($('#footer-prompt-sign-up-btn').length) {
    SiteImpressions.trackWhenInView({
      elementId: 'footer-prompt-sign-up-btn',
      category: 'Sign Up Footer',
      action: 'Viewed link',
      eventLabel: 'Sign Up for Free!',
      offset: 'bottom-in-view',
    });
  }

  if ($('#footer-expanded-sign-up-btn').length) {
    SiteImpressions.trackWhenInView({
      elementId: 'footer-expanded-sign-up-btn',
      category: 'Sign Up Footer',
      action: 'Viewed link',
      eventLabel: 'Sign Up for Free!',
      offset: 'bottom-in-view',
    });
  }

  $('.refer-a-friend-box .refer-a-friend-link.invite-friends').on('click touch', event => {
    bubEvents.track('Refer a Friend Footer', 'Clicked link', {
      label: $(event.target).text(),
    });
  });

  $('.sign-up-box .sign-up').on('click touch', () => {
    bubEvents.track('Sign Up Footer', 'Clicked link', {
      label: 'Sign Up',
    });
  });

  $('.sign-up-box.prompt .sign-up').on('click touch', event => {
    const signupTracker = new SiteConversionTrackingHelper('Footer signup section - prompt', event);
    signupTracker.trackConversion();
  });

  $('.sign-up-box.expanded .sign-up').on('click touch', event => {
    const signupTracker = new SiteConversionTrackingHelper('Footer signup section - email collection', event);
    signupTracker.trackConversion();
  });

  $('.footer-content .about-us-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'About Us',
    });
  });

  $('.footer-content .careers-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Careers',
    });
  });

  $('.footer-content .gift-a-book-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Gift A Book',
    });
  });

  $('.footer-content .gift-cards-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Gift Cards',
    });
  });

  $('.footer-content .logo-img').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Logo',
    });
  });

  $('.footer-content .how-to-listen-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'How to listen',
    });
  });

  $('.footer-content .faq-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Help',
    });
  });

  $('.footer-content .questions-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Questions Help',
    });
  });

  $('.footer-content .privacy-policy-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Privacy Policy',
    });
  });

  $('.footer-content .privacy-settings-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Your Privacy Choices',
    });
  });

  $('.footer-content .tos-link').on('click touch', event => {
    bubEvents.track('Footer', 'Clicked link', {
      label: $(event.target).text(),
    });
  });

  $('.why-chirp-content .about-us-button').on('click touch', () => {
    bubEvents.track('About Us Footer', 'Clicked button', {
      label: 'About Us',
    });
  });

  $('.footer-content .partners-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Partners',
    });
  });

  $('.footer-content .refund-policy-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Refund Policy',
    });
  });

  $('.footer-content .facebook-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Facebook',
    });
  });

  $('.footer-content .twitter-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Twitter',
    });
  });

  $('.footer-content .instagram-link').on('click touch', () => {
    bubEvents.track('Footer', 'Clicked link', {
      label: 'Instagram',
    });
  });
});
